import SectionTitle from "features/無料占いコンテンツ/components/atoms/SectionTitle";
import ContentsCard from "features/無料占いコンテンツ/components/organisms/ContentsCard";
import { Supervisor } from "shared/types";

import { useFreeFortuneContentList } from "repositories/hooks/useFreeFortuneContentList";

interface Props {
  fortuneTeller: Supervisor;
}

export const RelatedContentsFortuneTeller = ({ fortuneTeller }: Props) => {
  const { freeFortuneContents, isLoading, isError } = useFreeFortuneContentList(
    { fortuneTellerId: fortuneTeller.id }
  );

  if (isLoading || isError) return null;

  return (
    <div tw="pt-2.5 px-4">
      <div tw="my-5">
        <SectionTitle readMore>
          {fortuneTeller.name}先生のおすすめ無料占い
        </SectionTitle>
      </div>

      <ul>
        {freeFortuneContents.map((content) => (
          <li key={content.id}>
            <ContentsCard freeFortuneContent={content} />
          </li>
        ))}
      </ul>
    </div>
  );
};
